module.exports = __webpack_public_path__ + "img/google-playstore.1b5a3555.png";